import { AceEditorTheme } from 'modules/aceEditor';
import { BUTTON_VARIANTS } from 'ui/button';
import { colors } from 'ui/theme';
import { ToolbarTheme } from './types';

// Note: the default id will be assigned to the id of a div containing both the editor and the
// preview. The current value of the editor (for unit testing) can be obtained by getting the
// .textContent property of a nested child div with class 'ace_text-layer'
// test scenario: container.querySelector(`.ace_text-layer`).textContent
export const sideBySideDefaultId = 'content-editor-side-by-side';

export const testIds = {
  container: 'sbs-container',
  resizer: 'sbs-resizer',
  toolbar: 'sbs-toolbar',
  toolbarBtnUndo: 'sbs-toolbar-btn-undo',
  toolbarBtnRedo: 'sbs-toolbar-btn-redo',
  toolbarBtnCreativeLib: 'sbs-toolbar-btn-creative-lib',
  toolbarBtnMovableInk: 'sbs-toolbar-btn-movable-ink',
  toolbarBtnSnippets: 'sbs-toolbar-btn-snippets',
  toolbarBtnLoadHtml: 'sbs-toolbar-btn-load-html',
  toolbarBtnDynamicContentBuilder: 'sbs-toolbar-btn-dcb',
  toolbarInputLoadHtml: 'sbs-toolbar-input-load-html',
};

export const toolbarTheme: Record<AceEditorTheme, ToolbarTheme> = {
  [AceEditorTheme.Chrome]: {
    bgColor: `#EBEBEB`,
    borderColor: colors.grey15,
    btnVariant: BUTTON_VARIANTS.GHOST,
    shadow: 'MD',
  },
  [AceEditorTheme.Clouds]: {
    bgColor: `#EBEBEB`,
    borderColor: colors.grey15,
    btnVariant: BUTTON_VARIANTS.GHOST,
    shadow: 'MD',
  },
  [AceEditorTheme.Github]: {
    bgColor: `#E8E8E8`,
    borderColor: colors.grey15,
    btnVariant: BUTTON_VARIANTS.GHOST,
    shadow: 'MD',
  },
  [AceEditorTheme.Monokai]: {
    bgColor: `#2E3129`,
    borderColor: colors.grey80,
    btnVariant: BUTTON_VARIANTS.GHOSTINVERTED,
    shadow: 'XL',
  },
  [AceEditorTheme.Twilight]: {
    bgColor: `#232323`,
    borderColor: colors.grey80,
    btnVariant: BUTTON_VARIANTS.GHOSTINVERTED,
    shadow: 'XL',
  },
};
